/**
 * The console home, and the four views handover rev7 §11.7 gives a role that
 * another stage of `build/QUEUE.md` builds.
 *
 * They are in the menu because §11.7 puts them there, and leaving them out
 * would quietly shrink a role's job. What they must not do is look broken or
 * look finished: each one names the handover section it comes from and the
 * stage that owns it, out of `public.console_views`, so nobody files a bug
 * against a screen nobody has written yet.
 */

import { useLocation } from 'react-router-dom'

import { useConsole } from '../context.ts'

export function Home(): JSX.Element {
  const { session } = useConsole()
  const built = (session?.views ?? []).filter((view) => view.built)
  const pending = (session?.views ?? []).filter((view) => !view.built)

  return (
    <section data-testid="view-home">
      <h2>Üdvözöljük, {session?.staff.name ?? ''}</h2>
      <p className="lead">
        Szerepkör: {(session?.staff.roles ?? []).join(' · ')}. A nézeteket a §11.7 táblázata és a
        hozzáférési táblázat szabja meg; minden lekérés és minden művelet a kiszolgálón ellenőrzi
        őket újra.
      </p>

      <div className="grid">
        <article className="card">
          <h3>Elérhető nézetek</h3>
          <ul>
            {built.map((view) => <li key={view.key}>{view.label} — {view.note}</li>)}
          </ul>
        </article>
        {pending.length > 0 && (
          <article className="card">
            <h3>Még készül</h3>
            <ul data-testid="home-pending">
              {pending.map((view) => (
                <li key={view.key}>
                  {view.label} — {view.note} · <code>{view.built_by}</code>
                </li>
              ))}
            </ul>
          </article>
        )}
      </div>
    </section>
  )
}

export function NotBuilt(): JSX.Element {
  const { pathname } = useLocation()
  const { session } = useConsole()
  const view = (session?.views ?? []).find((candidate) => candidate.path === pathname)

  return (
    <section data-testid="view-not-built">
      <h2>{view?.label ?? 'Ez a nézet'}</h2>
      <p className="note gap">
        {view?.note ?? 'Handover rev7 §11.7'} — ezt a nézetet a{' '}
        <code>{view?.built_by ?? 'következő'}</code> lépés építi meg. A szerepköre megvan hozzá;
        a képernyő az, ami még nincs kész.
      </p>
    </section>
  )
}
